import { FileParameter } from "services/api/cplapi/CPLAPI";

/* eslint @typescript-eslint/no-explicit-any: 0 */
export class NewCommentModel implements INewCommentModel {
  commentThreadID?: string;
  message?: string | undefined;
  private?: boolean;
  attachments?: FileParameter[] | undefined;

  constructor(data?: INewCommentModel) {
    if (data) {
      for (const property in data) {
        if (Object.hasOwn(data, property)) (this as any)[property] = (data as any)[property];
      }
    }
  }
}

export interface INewCommentModel {
  commentThreadID?: string;
  message?: string | undefined;
  private?: boolean;
  attachments?: FileParameter[] | undefined;
}
